(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agen-app-landing"] && !Shopify.designMode) return;
  try {
    
    (function(){
      function initLucide(){ if(window.lucide&&window.lucide.createIcons){ try{window.lucide.createIcons();}catch(e){} } }
      if(!window.__agenLucideLoaded){ window.__agenLucideLoaded=true; var s=document.createElement("script"); s.src="https://unpkg.com/lucide@latest/dist/umd/lucide.min.js"; s.onload=initLucide; document.head.appendChild(s);} else { initLucide(); }
      setTimeout(initLucide,400); setTimeout(initLucide,1200);
      document.querySelectorAll(".agen-app").forEach(function(root){
        if(root.dataset.agenInit) return; root.dataset.agenInit="1";
        if("IntersectionObserver" in window){
          var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("is-in");io.unobserve(e.target);}});},{rootMargin:"0px 0px -8% 0px",threshold:.08});
          root.querySelectorAll(".reveal").forEach(function(el){io.observe(el);});
        } else { root.querySelectorAll(".reveal").forEach(function(el){el.classList.add("is-in");}); }
        // scroll showcase
        var screen=root.querySelector("#appScreen");
        var steps=root.querySelectorAll(".appstep");
        if(screen&&steps.length&&"IntersectionObserver" in window){
          screen.style.transition="opacity .25s ease";
          var so=new IntersectionObserver(function(es){
            es.forEach(function(e){
              if(e.isIntersecting){
                steps.forEach(function(x){x.classList.remove("is-active");});
                e.target.classList.add("is-active");
                var img=e.target.getAttribute("data-img");
                if(img && screen.getAttribute("src")!==img){ screen.style.opacity=0; setTimeout(function(){ screen.src=img; screen.style.opacity=1; },140); }
              }
            });
          },{rootMargin:"-45% 0px -45% 0px",threshold:0});
          steps.forEach(function(st){so.observe(st);});
        }
        initLucide();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agen-band-pdp"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initLucide() {
        if (window.lucide && window.lucide.createIcons) { try { window.lucide.createIcons(); } catch (e) {} }
      }
      if (!window.__agenLucideLoaded) {
        window.__agenLucideLoaded = true;
        var s = document.createElement("script");
        s.src = "https://unpkg.com/lucide@latest/dist/umd/lucide.min.js";
        s.onload = initLucide;
        document.head.appendChild(s);
      } else { initLucide(); }
      setTimeout(initLucide, 400); setTimeout(initLucide, 1200);

      document.querySelectorAll(".agen-band-pdp").forEach(function (root) {
        if (root.dataset.agenInit) return; root.dataset.agenInit = "1";
        var qty = 1;
        var moneyOnce = root.dataset.moneyOnce || "";

        // quantity
        var qN = root.querySelector("#agenQtyN"), qI = root.querySelector("#agenQty");
        var qd = root.querySelector("[data-qd]"), qu = root.querySelector("[data-qu]");
        if (qd) qd.addEventListener("click", function () { qty = Math.max(1, qty - 1); qN.textContent = qty; qI.value = qty; });
        if (qu) qu.addEventListener("click", function () { qty = Math.min(9, qty + 1); qN.textContent = qty; qI.value = qty; });

        // gallery thumbs
        root.querySelectorAll(".gthumb").forEach(function (t) {
          t.addEventListener("click", function () {
            root.querySelectorAll(".gthumb").forEach(function (x) { x.classList.remove("gthumb--active"); });
            t.classList.add("gthumb--active");
            var img = root.querySelector("#galImg");
            if (img) img.src = t.dataset.src;
          });
        });

        // variant (color) selection
        var idInput = root.querySelector("#agenVarId");
        var vlabel = root.querySelector("[data-variant-label]");
        var priceEl = root.querySelector("[data-price]");
        root.querySelectorAll("[data-variant-btn]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            root.querySelectorAll("[data-variant-btn]").forEach(function (x) { x.classList.remove("vbtn--active"); });
            btn.classList.add("vbtn--active");
            if (idInput) idInput.value = btn.dataset.variantId;
            if (vlabel) vlabel.textContent = btn.dataset.variantTitle;
            if (btn.dataset.img) { var g = root.querySelector("#galImg"); if (g) g.src = btn.dataset.img; }
            if (priceEl && btn.dataset.price) { priceEl.textContent = btn.dataset.price; moneyOnce = btn.dataset.price; }
          });
        });

        // faq
        root.querySelectorAll(".faq__q").forEach(function (q) {
          q.addEventListener("click", function () {
            var item = q.closest(".faq__item"); var open = item.classList.contains("faq__item--open");
            root.querySelectorAll(".faq__item").forEach(function (x) { x.classList.remove("faq__item--open"); });
            if (!open) item.classList.add("faq__item--open");
          });
        });

        // sticky bar
        var bar = root.querySelector("#agenBuybar");
        if (bar) addEventListener("scroll", function () {
          var past = scrollY > 820 && (document.body.scrollHeight - scrollY - innerHeight) > 520;
          bar.classList.toggle("buybar--show", past);
        }, { passive: true });

        // reveal on scroll
        if ("IntersectionObserver" in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
          }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
          root.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
        } else {
          root.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-in"); });
        }

        // add to cart
        var toast = root.querySelector("#agenToast"), tmsg = root.querySelector("[data-toast-msg]"), tt;
        var form = root.querySelector("#agen-band-form");
        if (form) form.addEventListener("submit", function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          var fd = new FormData(form);
          fetch("/cart/add.js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
            .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
            .then(function () {
              tmsg.textContent = root.querySelector(".pinfo__title").textContent + (qty > 1 ? " ×" + qty : "") + " added to cart";
              toast.classList.add("toast--show"); clearTimeout(tt);
              tt = setTimeout(function () { toast.classList.remove("toast--show"); }, 2600);
              document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true, detail: { source: "agen-band", data: { source: "agen-band" } } }));
            })
            .catch(function () { form.submit(); });
        });

        initLucide();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agen-cmp"]) return;
  try {
    
(function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}});},{threshold:.14});document.querySelectorAll(".rv").forEach(function(el){io.observe(el);});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agen-hiw"]) return;
  try {
    

(function(){
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:.16});
  document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agen-robot-pdp"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initLucide() { if (window.lucide && window.lucide.createIcons) { try { window.lucide.createIcons(); } catch (e) {} } }
      if (!window.__agenLucideLoaded) {
        window.__agenLucideLoaded = true;
        var s = document.createElement("script");
        s.src = window.__agenLucideSrc || "https://unpkg.com/lucide@0.456.0/dist/umd/lucide.min.js";
        s.onerror = function () { var f = document.createElement("script"); f.src = "https://unpkg.com/lucide@0.456.0/dist/umd/lucide.min.js"; f.onload = initLucide; document.head.appendChild(f); };
        s.onload = initLucide; document.head.appendChild(s);
      } else { initLucide(); }
      setTimeout(initLucide, 400); setTimeout(initLucide, 1200);

      document.querySelectorAll(".agen-robot-pdp").forEach(function (root) {
        if (root.dataset.agenInit) return; root.dataset.agenInit = "1";
        var qty = 1;
        var qN = root.querySelector("#agenQtyN"), qI = root.querySelector("#agenQty");
        var qd = root.querySelector("[data-qd]"), qu = root.querySelector("[data-qu]");
        if (qd) qd.addEventListener("click", function () { qty = Math.max(1, qty - 1); qN.textContent = qty; qI.value = qty; });
        if (qu) qu.addEventListener("click", function () {
          if (qty === 9) { showToast("Maximum 9 per order"); return; }
          qty = Math.min(9, qty + 1); qN.textContent = qty; qI.value = qty;
        });
        root.querySelectorAll(".gthumb").forEach(function (t) {
          t.addEventListener("click", function () {
            root.querySelectorAll(".gthumb").forEach(function (x) { x.classList.remove("gthumb--active"); });
            t.classList.add("gthumb--active");
            var img = root.querySelector("#galImg"); if (img) img.src = t.dataset.src;
          });
        });
        root.querySelectorAll(".faq__q").forEach(function (q) {
          q.addEventListener("click", function () {
            var item = q.closest(".faq__item"); var open = item.classList.contains("faq__item--open");
            root.querySelectorAll(".faq__item").forEach(function (x) { x.classList.remove("faq__item--open"); });
            if (!open) item.classList.add("faq__item--open");
          });
        });
        var bar = root.querySelector("#agenBuybar");
        if (bar) addEventListener("scroll", function () {
          var past = scrollY > 820 && (document.body.scrollHeight - scrollY - innerHeight) > 520;
          bar.classList.toggle("buybar--show", past);
        }, { passive: true });
        if ("IntersectionObserver" in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
          }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
          root.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
        } else { root.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-in"); }); }
        var toast = root.querySelector("#agenToast"), tmsg = root.querySelector("[data-toast-msg]"), tt;
        function showToast(msg) {
          tmsg.textContent = msg;
          toast.classList.add("toast--show"); clearTimeout(tt);
          tt = setTimeout(function () { toast.classList.remove("toast--show"); }, 2600);
        }
        if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) {
          root.querySelectorAll("video[autoplay]").forEach(function (v) { v.removeAttribute("autoplay"); try { v.pause(); } catch (e) {} });
        }
        var form = root.querySelector("#agen-robot-form");
        if (form) form.addEventListener("submit", function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          var fd = new FormData(form);
          fetch("/cart/add.js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
            .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
            .then(function () {
              showToast(root.querySelector(".pinfo__title").textContent + (qty > 1 ? " ×" + qty : "") + " added to cart");
              document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true, detail: { source: "agen-robot", data: { source: "agen-robot" } } }));
            })
            .catch(function () { form.submit(); });
        });
        initLucide();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agen-scale-pdp"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initLucide() {
        if (window.lucide && window.lucide.createIcons) { try { window.lucide.createIcons(); } catch (e) {} }
      }
      if (!window.__agenLucideLoaded) {
        window.__agenLucideLoaded = true;
        var s = document.createElement("script");
        s.src = "https://unpkg.com/lucide@latest/dist/umd/lucide.min.js";
        s.onload = initLucide;
        document.head.appendChild(s);
      } else { initLucide(); }
      setTimeout(initLucide, 400); setTimeout(initLucide, 1200);

      document.querySelectorAll(".agen-scale-pdp").forEach(function (root) {
        if (root.dataset.agenInit) return; root.dataset.agenInit = "1";
        var qty = 1;
        var moneyOnce = root.dataset.moneyOnce || "";

        // quantity
        var qN = root.querySelector("#agenQtyN"), qI = root.querySelector("#agenQty");
        var qd = root.querySelector("[data-qd]"), qu = root.querySelector("[data-qu]");
        if (qd) qd.addEventListener("click", function () { qty = Math.max(1, qty - 1); qN.textContent = qty; qI.value = qty; });
        if (qu) qu.addEventListener("click", function () { qty = Math.min(9, qty + 1); qN.textContent = qty; qI.value = qty; });

        // gallery thumbs
        root.querySelectorAll(".gthumb").forEach(function (t) {
          t.addEventListener("click", function () {
            root.querySelectorAll(".gthumb").forEach(function (x) { x.classList.remove("gthumb--active"); });
            t.classList.add("gthumb--active");
            var img = root.querySelector("#galImg");
            if (img) img.src = t.dataset.src;
          });
        });

        // variant (color) selection
        var idInput = root.querySelector("#agenVarId");
        var vlabel = root.querySelector("[data-variant-label]");
        var priceEl = root.querySelector("[data-price]");
        root.querySelectorAll("[data-variant-btn]").forEach(function (btn) {
          btn.addEventListener("click", function () {
            root.querySelectorAll("[data-variant-btn]").forEach(function (x) { x.classList.remove("vbtn--active"); });
            btn.classList.add("vbtn--active");
            if (idInput) idInput.value = btn.dataset.variantId;
            if (vlabel) vlabel.textContent = btn.dataset.variantTitle;
            if (btn.dataset.img) { var g = root.querySelector("#galImg"); if (g) g.src = btn.dataset.img; }
            if (priceEl && btn.dataset.price) { priceEl.textContent = btn.dataset.price; moneyOnce = btn.dataset.price; }
          });
        });

        // faq
        root.querySelectorAll(".faq__q").forEach(function (q) {
          q.addEventListener("click", function () {
            var item = q.closest(".faq__item"); var open = item.classList.contains("faq__item--open");
            root.querySelectorAll(".faq__item").forEach(function (x) { x.classList.remove("faq__item--open"); });
            if (!open) item.classList.add("faq__item--open");
          });
        });

        // sticky bar
        var bar = root.querySelector("#agenBuybar");
        if (bar) addEventListener("scroll", function () {
          var past = scrollY > 820 && (document.body.scrollHeight - scrollY - innerHeight) > 520;
          bar.classList.toggle("buybar--show", past);
        }, { passive: true });

        // reveal on scroll
        if ("IntersectionObserver" in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
          }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
          root.querySelectorAll(".reveal").forEach(function (el) { io.observe(el); });
        } else {
          root.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("is-in"); });
        }

        // add to cart
        var toast = root.querySelector("#agenToast"), tmsg = root.querySelector("[data-toast-msg]"), tt;
        var form = root.querySelector("#agen-scale-form");
        if (form) form.addEventListener("submit", function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          var fd = new FormData(form);
          fetch("/cart/add.js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
            .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
            .then(function () {
              tmsg.textContent = root.querySelector(".pinfo__title").textContent + (qty > 1 ? " ×" + qty : "") + " added to cart";
              toast.classList.add("toast--show"); clearTimeout(tt);
              tt = setTimeout(function () { toast.classList.remove("toast--show"); }, 2600);
              document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true, detail: { source: "agen-scale", data: { source: "agen-scale" } } }));
            })
            .catch(function () { form.submit(); });
        });

        initLucide();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agen-sci"]) return;
  try {
    
(function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}});},{threshold:.14});document.querySelectorAll(".rv").forEach(function(el){io.observe(el);});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agen-supp-pdp"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initLucide() {
        if (window.lucide && window.lucide.createIcons) { try { window.lucide.createIcons(); } catch (e) {} }
      }
      if (!window.__agenLucideLoaded) {
        window.__agenLucideLoaded = true;
        var s = document.createElement("script");
        s.src = "https://unpkg.com/lucide@latest/dist/umd/lucide.min.js";
        s.onload = initLucide;
        document.head.appendChild(s);
      } else { initLucide(); }
      setTimeout(initLucide, 400); setTimeout(initLucide, 1200);

      document.querySelectorAll(".agen-pdp").forEach(function (root) {
        if (root.dataset.agenInit) return; root.dataset.agenInit = "1";
        var qty = 1;
        var planInput = root.querySelector("#agenSellingPlan");
        var planValue = planInput ? planInput.value : "";
        // money strings are rendered server-side in the active currency — never computed here
        var moneySub = root.dataset.moneySub || "";
        var moneyOnce = root.dataset.moneyOnce || "";
        var activeOpt = root.querySelector(".buyopt--active");
        var plan = activeOpt ? activeOpt.getAttribute("data-plan") : "once";

        function refresh() {
          var bar = root.querySelector("[data-bar-price]");
          if (bar) bar.innerHTML = plan === "sub" ? (moneySub + " /mo · Subscribe &amp; Save") : moneyOnce;
          if (planInput) planInput.value = plan === "sub" ? planValue : "";
        }

        root.querySelectorAll(".buyopt").forEach(function (op) {
          function select() {
            root.querySelectorAll(".buyopt").forEach(function (x) { x.classList.remove("buyopt--active"); });
            op.classList.add("buyopt--active"); plan = op.dataset.plan; refresh();
          }
          op.addEventListener("click", select);
          op.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); select(); } });
        });

        var qN = root.querySelector("#agenQtyN"), qI = root.querySelector("#agenQty");
        var qd = root.querySelector("[data-qd]"), qu = root.querySelector("[data-qu]");
        if (qd) qd.addEventListener("click", function () { qty = Math.max(1, qty - 1); qN.textContent = qty; qI.value = qty; });
        if (qu) qu.addEventListener("click", function () { qty = Math.min(9, qty + 1); qN.textContent = qty; qI.value = qty; });

        root.querySelectorAll(".gthumb").forEach(function (t) {
          t.addEventListener("click", function () {
            root.querySelectorAll(".gthumb").forEach(function (x) { x.classList.remove("gthumb--active"); });
            t.classList.add("gthumb--active");
            var img = root.querySelector("#galImg"), main = root.querySelector("#galMain");
            if (img) { img.src = t.dataset.src; img.style.objectFit = t.dataset.fit; img.style.padding = t.dataset.fit === "contain" ? "40px" : "0"; }
            if (main) main.style.background = t.dataset.bg;
          });
        });

        root.querySelectorAll(".faq__q").forEach(function (q) {
          q.addEventListener("click", function () {
            var item = q.closest(".faq__item"); var open = item.classList.contains("faq__item--open");
            root.querySelectorAll(".faq__item").forEach(function (x) { x.classList.remove("faq__item--open"); });
            if (!open) item.classList.add("faq__item--open");
          });
        });

        var bar = root.querySelector("#agenBuybar");
        if (bar) addEventListener("scroll", function () {
          var past = scrollY > 760 && (document.body.scrollHeight - scrollY - innerHeight) > 520;
          bar.classList.toggle("buybar--show", past);
        }, { passive: true });

        var toast = root.querySelector("#agenToast"), tmsg = root.querySelector("[data-toast-msg]"), tt;
        var form = root.querySelector("#agen-pdp-form");
        if (form) form.addEventListener("submit", function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          var fd = new FormData(form);
          fetch("/cart/add.js", { method: "POST", body: fd, headers: { "Accept": "application/json" } })
            .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
            .then(function () {
              tmsg.textContent = root.querySelector(".pinfo__title").textContent + (qty > 1 ? " ×" + qty : "") + " added to protocol";
              toast.classList.add("toast--show"); clearTimeout(tt);
              tt = setTimeout(function () { toast.classList.remove("toast--show"); }, 2600);
              // Notify Horizon's <cart-icon> (ThemeEvents.cartUpdate) so the header basket refreshes immediately
              document.dispatchEvent(new CustomEvent("cart:update", { bubbles: true, detail: { source: "agen-pdp", data: { source: "agen-pdp" } } }));
            })
            .catch(function () { form.submit(); });
        });

        refresh(); initLucide();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agen-v4-whitepaper"] && !Shopify.designMode) return;
  try {
    
  (function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}});},{threshold:.14});document.querySelectorAll(".wph .rv").forEach(function(el){io.observe(el);});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agen-whitepaper"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}});},{threshold:.12});
    document.querySelectorAll(".wpl .rv").forEach(function(el){io.observe(el);});
    // If we returned in the success state, bring the card into view.
    if(/[?&]customer_posted=true/.test(location.search)){
      var c=document.getElementById("wp-form");
      if(c){ setTimeout(function(){ c.scrollIntoView({behavior:"smooth",block:"center"}); },300); }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
